import { useEffect, useState } from 'react';
import useDispatch from 'client/hooks/useDispatch';
import requestUtilityApi from 'client/actions/requestUtilityApi';
import {
  SR_API_ACTION_UTILITY_PARTNER_ADDRESS_UPDATE_ADDRESS,
  SR_API_ACTION_UTILITY_PARTNER_ADDRESS_GET_BY_ID,
} from 'api/utilityActionTypes';

const useAddressVerificationController = ({ item, reloadItems }) => {
  const dispatch = useDispatch();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [successModalType, setSuccessModalType] = useState(null);
  const [listingResponse, setListingResponse] = useState(null);
  const [isListingLoading, setIsListingLoading] = useState(false);

  useEffect(() => {
    if (!item?.listingId) {
      return undefined;
    }

    const fetchListing = async () => {
      setIsListingLoading(true);
      try {
        const loadedListing = await dispatch(requestUtilityApi, {
          action: SR_API_ACTION_UTILITY_PARTNER_ADDRESS_GET_BY_ID,
          payload: {
            id: item.listingId,
          },
        });
        setListingResponse(loadedListing || null);
      } catch (error) {
        setErrorMessage(error?.message || 'Failed to load listing. Please try again.');
      } finally {
        setIsListingLoading(false);
      }
    };

    fetchListing();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item.addressId, item.listingId, item.partnerId]);

  const handleListingAddressUpdate = ({ addressFields, onSuccess }) => {
    if (!item?.listingId) {
      setErrorMessage('Missing listing id. Please try again.');
      return;
    }

    if (!addressFields || Object.keys(addressFields).length === 0) {
      setErrorMessage('Missing address details. Please complete the form.');
      return;
    }

    setErrorMessage(null);
    setIsSubmitting(true);

    dispatch(requestUtilityApi, {
      action: SR_API_ACTION_UTILITY_PARTNER_ADDRESS_UPDATE_ADDRESS,
      payload: {
        id: item.listingId,
        updates: {
          addressFields,
        },
      },
      onSuccess: () => {
        setIsSubmitting(false);
        setSuccessModalType('resolved');
        if (typeof onSuccess === 'function') {
          onSuccess();
        }
        if (reloadItems) {
          reloadItems({ removeEntityId: item.id });
        }
      },
      onError: (error) => {
        setErrorMessage(error?.message || 'Failed to update address. Please try again.');
        setIsSubmitting(false);
      },
    });
  };

  const handleCloseSuccessModal = () => {
    setSuccessModalType(null);
  };

  return {
    state: {
      isSubmitting,
      errorMessage,
      successModalType,
      listing: listingResponse?.listing,
      address: listingResponse?.address,
      isListingLoading,
    },
    handlers: {
      handleListingAddressUpdate,
      handleCloseSuccessModal,
    },
  };
};

export default useAddressVerificationController;
